import { ServiceTypeSwitch } from '@components/ServiceTypeSwitch'

import { APP_TITLE_BY_SERVICE_TYPE } from '@constants'

interface PageTitleProps {
  subtitle?: string
}

export function PageTitle({ subtitle }: PageTitleProps) {
  function titleFor(appTitle: string) {
    return <title>{subtitle ? `${subtitle} | ${appTitle}` : appTitle}</title>
  }

  return (
    <ServiceTypeSwitch
      autotax={titleFor(APP_TITLE_BY_SERVICE_TYPE.autotax)}
      quickkeret={titleFor(APP_TITLE_BY_SERVICE_TYPE.quickkeret)}
    />
  )
}
